import * as types from './actionTypes';

export const fetchPermissionPolicyRequest = (unit_id) => ({
  type: types.FETCH_PERMISSION_POLICY_REQUEST,
  payload:{unit_id}
});

export const fetchPermissionPolicySuccess = (data) => ({
  type: types.FETCH_PERMISSION_POLICY_SUCCESS,
  payload: data,
});

export const fetchPermissionPolicyFailure = (error) => ({
  type: types.FETCH_PERMISSION_POLICY_FAILURE,
  payload: error,
});

export const savePermissionPolicyRequest = (payload) => ({
  type: types.SAVE_PERMISSION_POLICY_REQUEST,
  payload,
});

export const savePermissionPolicySuccess = (response) => ({
  type: types.SAVE_PERMISSION_POLICY_SUCCESS,
  payload: response,
});

export const savePermissionPolicyFailure = (error) => ({
  type: types.SAVE_PERMISSION_POLICY_FAILURE,
  payload: error,
});
